// extracted by mini-css-extract-plugin
export var closeButton = "_3e-3";
export var header = "_3e-0";
export var link = "_3e-1";
export var retryButton = "_3e-2";